import React from 'react';
import { CONTACT_EMAIL } from '@op/constants';
import brand_health_formula from '@op/assets/svg/brand_health_formula.svg';
import brand_health_formula_when_en from '@op/assets/svg/brand_health_formula_when_en.svg';
import brand_health_formula_when_zh from '@op/assets/svg/brand_health_formula_when_zh.svg';

export default [
  {
    metrics_cn: '评论',
    metrics_en: 'Reviews',
    desc_cn:
      '1、游戏在应用商店下的所有评论（Appstore来源的数据因释放时间有延时，50小时后稳定）\n2、通过监控词和官号在社交媒体上抓取到的评论（超过97%的评论在10小时内能够抓取）',
    desc_en:
      '1. All comments of the game in the app store (the data from the Appstore is delayed due to the release time, and will be stable after 50 hours)\n2. Comments captured on social media through monitoring words and official accounts (more than 97% of comments can be captured within 10 hours)',
    granularity_cn: '分',
    granularity_en: 'Minute',
  },
  {
    metrics_cn: '声量，评论数',
    metrics_en: 'Mentions',
    desc_cn:
      '全网抓取到的玩家评论数量。包括游戏在应用商店下的所有评论，以及通过监控词和官号在社交媒体上抓取到的评论；',
    desc_en:
      'The number of player comments fetched from the entire network. Including all comments of the game in the app store, as well as comments captured on social media through keywords monitoring and official accounts;',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '情感分',
    metrics_en: 'Sentiment',
    desc_cn:
      '情感分是通过NLP算法和情感分析来对每条评论的情感倾向进行打分，分值范围为1-5。情感分大于3.5为正面，小于2.5为负面，在2.5到3.5之间为中性。',
    desc_en:
      'The sentiment score is used to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, on a scale of 1-5. Sentiment score greater than 3.5 is positive, score lower than 2.5 is negative, and score between 2.5-3.5 is neutral.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '品牌健康度',
    metrics_en: 'Brand Health',
    desc_cn: (
      <>
        品牌健康度：基于情感分对不同渠道和不同有效性评论进行加权计算，变化趋势对于游戏正负事件更敏感。分数从-100到100，越高表示舆情反馈越积极。
        只有当正面声量和负面声量的总和超过10才计算品牌健康度。
        <br />
        品牌健康度计算公式为：
        <br />
        <br />
        <img src={brand_health_formula}></img>
        <br />
        <img src={brand_health_formula_when_zh}></img>
        <br />
        <br />
        公式中的
        <br />
        #Pos_social和#Neg_social分别代表社交媒体/新闻媒体上的正面评价和负面评价数量；
        <br />
        #Pos_store和#Neg_store则对应游戏商店内的正面评价和负面评价数量。
        <br />
        其中评论都过滤了视频标题类型。
        <br />
        W是权重系数，用于平衡社交媒体/新闻媒体和游戏商店评价的重要程度。
        <br />
        <br />
        品牌健康度得分的不同区间反映了游戏的健康程度：
        <br />
        1、得分低于-70表示品牌处于非常不健康的状况
        <br />
        2、得分介于-70至-25之间表示品牌健康状况不佳
        <br />
        3、得分在-25至25之间表示被品牌为中性状态
        <br />
        4、得分位于25至50之间表示品牌较为健康
        <br />
        5、得分超过50则表示品牌非常健康
      </>
    ),
    desc_en: (
      <>
        Brand Health: The Brand Health Score is calculated by weighting
        sentiment across different channels and varying levels of reviews
        validation. The trend is more sensitive to positive and negative events.
        The score ranges from -100 to 100, with higher scores indicating more
        positive feedback. Available for calculation only if the combined total
        of positive and negative mentions is greater than 10.
        <br />
        <br />
        The formula for calculating the Brand Health Score is: <br />
        <img src={brand_health_formula}></img> <br />
        <img src={brand_health_formula_when_en}></img> <br /> <br />
        Where: <br />
        #Pos_social and #Neg_social represent the number of positive and
        negative reviews on social media/news media, respectively. <br />
        #Pos_store and #Neg_store represent the number of positive and negative
        reviews in the game store, respectively. <br />
        All reviews are filtered to exclude video title type. <br />W is a
        weight coefficient used to balance the importance of social media/news
        media and game store reviews. <br /> <br />
        Different ranges of the Brand Health Score reflect varying degrees of
        health for the game: <br />
        1、A score below -70 indicates that the brand is in a very unhealthy
        state. <br />
        2、A score between -70 and -25 indicates that the brand's health is
        poor. <br />
        3、A score between -25 and 25 indicates a neutral status for the brand.{' '}
        <br />
        4、A score between 25 and 50 indicates that the brand is relatively
        healthy. <br />
        5、A score above 50 indicates that the brand is very healthy.
      </>
    ),
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '商店评论累计评分',
    metrics_en: 'Lifetime Game Score',
    desc_cn:
      '在所选时间和地区，游戏商店的最新评分，评分范围是1到5颗星。只支持筛选时间和地区',
    desc_en:
      'The latest rating from the game store for the selected time and region, on a scale of 1 to 5 stars. Only supports filtering of time and region.',
    granularity_cn: '日',
    granularity_en: 'Day',
  },
  {
    metrics_cn: '选中商店评论评分',
    metrics_en: 'Selected Game Score',
    desc_cn:
      '在所选条件(比如：评论时间，地区和话题)用户在Game Store中给出的评分，评分范围是1到5颗星。支持筛选时间，渠道，语种，地区，商店评分',
    desc_en:
      'Ratings given by users in the Game Store based on selected criteria (eg comment time, region and topic) on a scale of 1 to 5 stars. Support filtering of time, channel, language, region, store rating',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '好评率',
    metrics_en: 'Positive%',
    desc_cn:
      '玩家在steam官网上给出 Recommend (即赞)评分的数量，占总评论数的比例（*该评分只统计在steam平台上购买了该游戏的用户评论',
    desc_en:
      'The number of Recommend (like) ratings given by players on the official Steam website, as a percentage of the total number of reviews (*This rating only counts the reviews of users who have purchased the game on the Steam platform',
    granularity_cn: '日',
    granularity_en: 'Day',
  },
  {
    metrics_cn: '评分',
    metrics_en: 'Steam Overall Reviews',
    desc_cn:
      '1、Steam平台根据好评率统计出的评分,评论人数（*该评分只统计在steam平台上购买了该游戏的用户评论）\n2、评分机制：Overwhelmingly positive, Very positive,Mostly positive, Mixed, Mostly negative, Very negative, Overwhelmingly negative',
    desc_en:
      '1. The rating and the number of comments calculated by the Steam platform based on the favorable rate (*This rating only counts the comments of users who purchased the game on the Steam platform) \n2. Scoring mechanism: Overwhelmingly positive, Very positive, Mostly positive, Mixed, Mostly negative , Very negative, Overwhelmingly negative',
    granularity_cn: '日',
    granularity_en: 'Day',
  },
  {
    metrics_cn: '玩家评论',
    metrics_en: 'Gamer Reviews',
    desc_cn:
      '1、每条玩家评论详情+用户评分\n2、评分机制：踩(Not Recommend)和赞(Recommend)',
    desc_en:
      '1. Details of each player comment + user rating \n2. Rating mechanism: Dislike (Not Recommend) and Like (Recommend)',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '大众媒体评分',
    metrics_en: 'Meta Score',
    desc_cn:
      '媒体在Metacritic网站给出的评分均值，评分的媒体数量，评分范围是0-100',
    desc_en:
      'The average score given by the media on the Metacritic website, the number of media scores, and the score range is 0-100',
    granularity_cn: '日',
    granularity_en: 'Day',
  },
  {
    metrics_cn: '用户评分',
    metrics_en: 'User Score',
    desc_cn:
      '用户在Metacritic网站给出的评分均值，评分的用户数量，评分范围是1-10',
    desc_en:
      'The average score given by users on the Metacritic website, the number of users who scored, and the score range is 1-10',
    granularity_cn: '日',
    granularity_en: 'Day',
  },
  {
    metrics_cn: '媒体评论',
    metrics_en: 'Metacritic Critic Reviews',
    desc_cn:
      '1、每条每条媒体评论详情+媒体评分（评分范围是0-100）\n2、评分机制：当分值范围是0-40时，代表Negative负面；当分值范围是41-70时，代表Mixed褒贬不一；当分值范围是71-100时，代表Positive正面',
    desc_en:
      '1. Details of each media comment + media score (the score range is 0-100)\n 2. Scoring mechanism: when the score range is 0-40, it means Negative; when the score range is 41-70, it means Mixed; when the score range is 71-100, it means Positive.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '用户评论',
    metrics_en: 'User Reviews',
    desc_cn:
      '1、每条用户评论详情+用户评分（评分范围是0-10）\n2、评分机制：当分值范围是1-4时，代表Negative负面；当分值范围是5-7时，代表Mixed褒贬不一；当分值范围是8-10时，代表Positive正面',
    desc_en:
      '1. Details of each user comment + user rating (score range is 0-10) \n2. Scoring mechanism: when the score range is 1-4, it means Negative; when the score range is 5-7, it means Mixed; when the score range is 8-10, it means Positive',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '头部媒体的平均评分',
    metrics_en: 'Top Critic Average',
    desc_cn: '头部媒体(Top critic)在Opencritic网站给出的评分均值',
    desc_en: 'The average score given by Top critic on the Opencritic website',
    granularity_cn: '日',
    granularity_en: 'Day',
  },
  {
    metrics_cn: '媒体推荐度',
    metrics_en: 'Critics Recommend',
    desc_cn:
      '媒体(包含头部媒体和其它媒体)在Opencritic网站给出的评分（换算成百分制），评分的媒体数量',
    desc_en:
      'The rating of the media (including top media and other media) on the Opencritic website (converted to a percentage system), and the number of rated media',
    granularity_cn: '日',
    granularity_en: 'Day',
  },
  {
    metrics_cn: '媒体评论',
    metrics_en: 'Opencritic Critic Reviews',
    desc_cn:
      '1、每条媒体评论详情+媒体评分\n2、评分机制：五星制，十分制，百分制并存，并存在unscored',
    desc_en:
      '1. Details of each media comment + media score \n2. Scoring mechanism: five-star system, ten-point system, and hundred-point system coexist, and there is unscored',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '用户评论',
    metrics_en: 'Audience Reviews',
    desc_cn:
      '1、每条用户评论详情+用户评分(评分区分 踩和赞)\n2、评分机制：踩和赞',
    desc_en:
      '1. Details of each user comment + user rating (distinguish between dislikes and likes) \n2. Scoring mechanism: dislikes and likes',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '关键词',
    metrics_en: 'Keyword',
    desc_cn:
      '1、提供Common 常见关键词，例如：服务器，登录，画面，机器人等1000多个关键词，持续更新关键词库\n2、支持业务配置Customized自定义关键词\n3、根据评论实时j计算出 Emerging Words 突发词, Hot Words 热词',
    desc_en:
      '1. Provide common keywords, such as: server, login, screen, robot and more than 1,000 keywords, continuously update the keyword database \n2. Support business configuration Customized custom keywords \n3. Calculate Emerging Words in real time according to comments Words, Hot Words',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '话题',
    metrics_en: 'Topic',
    desc_cn:
      '1、提供通用话题（内容如下）\nAccount Login账号登录，Gameplay玩法，Monetization商业化，Network Performance网络安全， Overall Emotion情绪，Security 安全，Sensory Experience 感官体验，Version 版本。\n2、支持业务配置自定义话题',
    desc_en:
      '1. Provide general topics (the contents are as follows) Account Login account login, Gameplay gameplay, Monetization commercialization, Network Performance network security, Overall Emotion, Security, Sensory Experience, Version version. \n2. Support business configuration custom topics',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '来源渠道',
    metrics_en: 'Channel',
    desc_cn:
      '1、Game Store: (mobile游戏)App Store, Google Play, (PC游戏)Steam, Metacritic，Opencritic\n2、Social Media: Facebook, Twitter等9个渠道\n3、News Media: Google News等124个渠道',
    desc_en:
      '1. Game Store: (mobile games) App Store, Google Play, (PC games) Steam, Metacritic, Opencritic \n2. Social Media: 9 channels such as Facebook, Twitter \n3. News Media: 124 channels such as Google News',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '语种',
    metrics_en: 'Language',
    desc_cn:
      '评论的语种，支持识别150多种语言，例如：阿拉伯语，葡萄牙语，西班牙语等',
    desc_en:
      'The language of comments, supports recognition of more than 150 languages, such as: Arabic, Portuguese, Spanish, etc.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '国家/地区',
    metrics_en: 'Region/Country',
    desc_cn:
      'App Store, Google Play来源的评论可以区分国家/地区，目前支持164个国家，例如：日本，韩国，美国，巴西，墨西哥，土耳其，俄罗斯等',
    desc_en:
      'App Store, Google Play source reviews, can be distinguished by countries, currently support 164 countries, such as: Japan, South Korea, United States, Brazil, Mexico, Turkey, Russia, etc.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '评论目的',
    metrics_en: 'Purpose',
    desc_cn: '评论的倾向，例如：Positive 积极，Suggestion 建议，Bug 缺陷',
    desc_en: 'Tendency to comment, e.g.: Positive, Suggestion, Bug',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '版本',
    metrics_en: 'Version',
    desc_cn: '评论的游戏版本',
    desc_en: 'Game version of the comment',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '监控关键词',
    metrics_en: 'Keyword Monitoring',
    desc_cn: '业务配置的定位评论的关键词',
    desc_en: 'Keywords of configured reviews for business demand',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '监控官号',
    metrics_en: 'Account Monitoring',
    desc_cn: '业务配置的定位评论的游戏官号',
    desc_en: 'Official accounts of configured reviews for business demand',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },

  {
    metrics_cn: '潜在曝光',
    metrics_en: 'Potential Impressions',
    desc_cn: `潜在曝光是指用户浏览信息的次数。这包括了所有发布本游戏相关主贴（包括文字贴或视频）的用户粉丝总数（不去重）\n一个发帖人发布多个帖子，粉丝数计算多次。\n如有疑问请联系${CONTACT_EMAIL}。`,
    desc_en: `Potential Impressions is the number of times audiences could've viewed messages. This includes the total number of followers of all users who post text or videos related to this game without deduplication.\nIf a user posts multiple posts, the number of followers is counted multiple times.\nFeel free to contact ${CONTACT_EMAIL} if you have any questions.`,
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '	发帖量',
    metrics_en: 'Publications',
    desc_cn:
      '在当前筛选条件下，本游戏的所有视频和文字贴的总和。暂未包含直播数据。',
    desc_en:
      'The total number of video and text main posts for this game under the current filter conditions. Streaming data is not yet included.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '发帖人数量',
    metrics_en: 'Number of Creators',
    desc_cn:
      '在当前筛选条件下，发布过视频或文字主贴的用户，并依据渠道和用户名进行去重',
    desc_en:
      'Users who have posted videos or text posts, with duplicates eliminated based on channel and username.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '观看量',
    metrics_en: 'View',
    desc_cn:
      '观看量是指本游戏相关的所有视频贴观看量及文字贴实际曝光量。未包含直播数据。',
    desc_en:
      'Views represent the total number of video views and actual exposure counts for posts for this game. Streaming data is not included.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '互动量',
    metrics_en: 'Engagement',
    desc_cn:
      '在当前筛选条件下，统计本游戏所有视频贴、文字贴及评论的总互动量，互动量涵盖点赞、点踩、评论和转发。暂未包含直播数据。',
    desc_en:
      'The total engagement count for all videos, posts, and comments for this game, including likes, dislikes, comments, and shares, under the current filter conditions. Streaming data is not yet included.',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '互动率',
    metrics_en: 'Engagement%',
    desc_cn:
      `互动率是用户互动量占潜在曝光量的百分比。该指标展示了用户与游戏品牌的互动程度。\n互动率 = 互动量 / 潜在曝光量\n如有疑问请联系${CONTACT_EMAIL}。`,
    desc_en:
      `The number of times users engaged with your content as a percentage of potential impressions. This indicates how engaged people are with your brand.\nEngagement Rate = Engagement / Potential Impressions\nFeel free to contact ${CONTACT_EMAIL} if you have any questions.`,
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '中文翻译',
    metrics_en: 'Translate to Chinese',
    desc_cn: '关键词和评论的中文翻译',
    desc_en: 'Chinese translation of keywords and comments',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
  {
    metrics_cn: '英文翻译',
    metrics_en: 'Translate to English',
    desc_cn: '关键词和评论的英文翻译',
    desc_en: 'English translation of keywords and comments',
    granularity_cn: '时',
    granularity_en: 'Hour',
  },
];
